/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path languageswitch
 * @description Language switch
 */
import LSwitch from "./LanguageSwitchView";
import RTLP from "./RTLProvider";
export const LanguageSwitchView = LSwitch;
export const RTLProvider = RTLP;
